export default __webpack_public_path__ + "static/media/callus.44c97e4e.svg";